
import Cookies from 'js-cookie';

export function resetFavourites() {
  var favourites = Cookies.get('user_favourites');
  if (!favourites) {
    favourites = [];
  } else {
    favourites = JSON.parse(favourites);
  }
  return favourites;
}

export default function initFavourites($){

  
    function addFavButtons(){
    $('.resource-slider-card').each(function(){
      const netsButton = $('<a/>', {
        text: ' ',
        href: '#',
        class: 'resource-card-icon resource-card__nets-australia'
      });

      const favButton = $('<button/>', {
        text: ' ',
        type: 'button',
        class: 'button_fav resource-card-icon resource-card__favourite',
        'aria-label': 'Add to favourites',
        'aria-pressed': 'false'
      });

      if ($(this).hasClass('is-nets-australia-resource')) {
        $(this).find('.n2-ss-section-main-content').append(netsButton);
      }
      $(this).find('.n2-ss-section-main-content').append(favButton);
    });
  }   



  function addToFavourites(id) {
    var favourites = resetFavourites();
    if (favourites.includes(id)) {
      favourites = favourites.filter(function(favId){
        return favId !== id;
      });
      Cookies.set('user_favourites', JSON.stringify(favourites), { expires: 365 });
      $('.favourable.favid-' + id).removeClass('is-favourite');
      $('.favourable.favid-' + id).find('.resource-card__favourite').attr('aria-pressed', 'false');
    } else {
      favourites.push(id);
      Cookies.set('user_favourites', JSON.stringify(favourites), { expires: 365 });
      $('.favourable.favid-' + id).addClass('is-favourite');
      $('.favourable.favid-' + id).find('.resource-card__favourite').attr('aria-pressed', 'true');
    } 
    return favourites;
  }

  function getFavouriteId(element) {
    var elementWithId = element.closest('.favourable');
    var elementclasses = elementWithId.className.split(' ');
    var favId = null;
    elementclasses.forEach(function(classname){
      if (classname.startsWith('favid-')) {
        favId = classname.replace('favid-','');
      }
    });
    return favId;
  }

  function initializeFavouritesUI() {
    var favourites = resetFavourites();
    favourites.forEach(function(favId){
      $('.favourable.favid-' + favId).addClass('is-favourite');
      $('.favourable.favid-' + favId).find('.resource-card__favourite').attr('aria-pressed', 'true');
    });
  }


  setTimeout(() => {
    addFavButtons();
    resetFavourites();
    initializeFavouritesUI();
  }, 100);
  

  $(document).on('click','.resource-card-icon.resource-card__favourite',function($){
    var e = $.originalEvent;
    e.preventDefault();

    var fav_id = getFavouriteId(this);
    addToFavourites(fav_id);
  });


}
